import {
  IFlightCategoryState,
  actionTypes,
} from 'src/ducks/flight-category.duck';
import { IStatus } from 'src/libraries/thunk.library';

export const getFlightCategoryStatus = (
  state: IFlightCategoryState,
  action: keyof typeof actionTypes
): IStatus =>
  state.status[action] ?? {
    fetching: false,
    error: null,
  };
